import * as React from 'react'
import { KeyValueText } from 'components'
import { Grid } from 'cs-kevlar-react'
import { serverDateToLocaleDateTimeString } from 'utils/dates'
import { AuditEventSearchResult } from '../../api'

interface EventOverviewProps {
  event: AuditEventSearchResult
}

export const EventOverview: React.FunctionComponent<EventOverviewProps> = ({
  event,
}) => {
  return (
    <Grid container spacing={8}>
      <Grid item xs={6}>
        <KeyValueText label="Date">
          {serverDateToLocaleDateTimeString(event.eventTimestamp)}
        </KeyValueText>
      </Grid>

      <Grid item xs={6}>
        <KeyValueText label="Customer">{event.customerAgencyName}</KeyValueText>
      </Grid>

      <Grid item xs={6}>
        <KeyValueText label="Agency">{event.licensedAgencyName}</KeyValueText>
      </Grid>

      <Grid item xs={6}>
        <KeyValueText label="User">{event.byUsername}</KeyValueText>
      </Grid>

      <Grid item xs={12}>
        <KeyValueText label="Event">{event.eventTypeDescription}</KeyValueText>
      </Grid>
    </Grid>
  )
}
